import { render } from "./PdfSendExtendedDataModal.vue?vue&type=template&id=b947059e"
import script from "./PdfSendExtendedDataModal.vue?vue&type=script&lang=js"
export * from "./PdfSendExtendedDataModal.vue?vue&type=script&lang=js"

import "./PdfSendExtendedDataModal.vue?vue&type=style&index=0&id=b947059e&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\45\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__